/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Mentions_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Type @ and pick a file, space, or artifact from your project. Its full content is added to the conversation, so the assistant can read and reason over it rig..." |
*
* @param {Uno_Edu_Chat_Mentions_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_mentions_chip1_answer = /** @type {((inputs?: Uno_Edu_Chat_Mentions_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Mentions_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie @ ein und wählen Sie eine Datei, einen Space oder ein Artefakt aus Ihrem Projekt. Der vollständige Inhalt wird der Konversation hinzugefügt, sodass der Assistent ihn sofort lesen und verarbeiten kann. Durchsuchen Sie nach Kategorie oder tippen Sie, um zu suchen.")
	return /** @type {LocalizedString} */ ("Type @ and pick a file, space, or artifact from your project. Its full content is added to the conversation, so the assistant can read and reason over it right away. Browse by category or type to search.")
});